
import { Component, Ref, Vue } from 'vue-property-decorator'
import ModalPassword from '@/components/templates/manage/ModalPassword.vue'
import PasswordUtils from '@/utils/PasswordUtils'
import { UsersApi } from '@/api/methods/manage/UsersApi'
import { ApiConflictAppError } from '@/models/AppErrorClasses'

/**
 * パスワード変更モーダル
 */
@Component({
  components: {
    ModalPassword,
  },
})
export default class ModalEditPassword extends Vue {
  /** パスワード変更モーダルのフォーマット */
  @Ref()
  modalPassword!: ModalPassword

  /** 変更対象のユーザID */
  private userId: number = 0

  /**
   * 送信ボタンのdisabled制御
   *
   * @param newPassword パスワード
   * @param confirm 確認用パスワード
   * @returns 未入力があった場合はtrue
   */
  private submitDisabled(newPassword: string, confirm: string): boolean {
    // パスワードが未入力の場合true
    if (!newPassword) {
      return true
    }

    // 確認用パスワードが未入力の場合true
    if (!confirm) {
      return true
    }

    return false
  }

  /**
   * 変更ボタン押下時の処理
   */
  private async submitPassword(): Promise<void> {
    this.$loading.start()

    let errorMessage = null

    // パスワードのバリデーションチェック
    errorMessage = this.validPassword()
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    // パスワード指定が適切かのチェック
    errorMessage = PasswordUtils.checkPasswordEnabled(this.modalPassword.newPassword)
    if (errorMessage) {
      alert(errorMessage)
      this.$loading.complete()
      return
    }

    try {
      // パスワード更新
      await UsersApi.updateUserPassword(this.userId, this.modalPassword.newPassword)
    } catch (error) {
      if (error instanceof ApiConflictAppError) {
        alert('現在のパスワードと同じパスワードは使用できません。')
        this.$loading.complete()
        return
      }

      // 400エラー以外の場合は例外を投げ直し、共通処理に渡す
      throw error
    }

    this.$loading.complete()

    // モーダルを閉じる
    this.hide()
  }

  /**
   * パスワードのバリデーションチェック
   *
   * @returns 確認用パスワードと不一致の場合エラーメッセージを返す
   */
  public validPassword(): string | null {
    if (this.modalPassword.newPassword !== this.modalPassword.confirm) {
      return '新規パスワードと確認用パスワードが一致しません'
    }

    return null
  }

  /**
   * モーダルを開く
   *
   * @param userId ユーザID
   */
  public show(userId: number): void {
    this.userId = userId
    this.modalPassword.show()
  }

  /**
   * モーダルを閉じる
   */
  private hide(): void {
    this.modalPassword.hide()
  }
}
